<template>
  <div>
    <Row style="padding: 20px">
      <Col span="18">
        <div class="status">
          <div
            v-for="(item, index) in sectionList"
            :key="index"
            :class="[
              'status-item',
              tab == item.code ? 'status-item-active' : '',
            ]"
            @click="tabNav(item.code)"
          >
            {{ item.name }}
          </div>
        </div>
      </Col>
      <Col span="6">
        <Button
          type="primary"
          icon="md-add"
          class="public-fr"
          @click="openContent()"
          >添加广告</Button
        >
      </Col>
      <Col span="24">
        <Col span="24" style="margin-bottom: 20px">
          <Input
            v-model="params.title"
            placeholder="请输入广告标题"
            class="public-inp"
          />
          <Button type="primary" icon="md-search" @click="handleSearch(tab)"
            >搜索</Button
          >
          <Button @click="resetList()">重置</Button>
        </Col>
        <!-- 广告列表 -->
        <Table
          class="table"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="advList.list || []"
        >
          <template slot-scope="{ index }" slot="no">
            <span>{{
              params.pageSize * (params.pageNum - 1) + index + 1
            }}</span>
          </template>
          <template slot-scope="{ row }" slot="imgUrl">
            <img
              :src="row.imageUrlView[0]"
              class="img_url"
              v-if="row.imageUrlView && row.imageUrlView.length > 0"
            />
            <span v-else>暂无</span>
          </template>
          <template slot-scope="{ row }" slot="status">
            <!-- 1=启用；2=禁用 -->
            <i-switch
              :value="row.status == 1"
              @on-change="(v) => updateState(v, row)"
              size="small"
            />
          </template>
          <template slot-scope="{ row }" slot="action">
            <a href="javascript:;" @click="openContent(row)">编辑</a>
            <a href="javascript:;" @click="removeContent(row)">删除</a>
          </template>
        </Table>
        <Page
          :style="{ float: 'right', marginTop: '10px' }"
          :total="advList.total"
          :current.sync="params.pageNum"
          :page-size-opts="[10, 20, 30, 100]"
          :page-size="params.pageSize"
          show-sizer
          show-total
          prev-text="Previous"
          next-text="Next"
          show-elevator
          @on-change="(val) => pageNumChange(val, 'params')"
          @on-page-size-change="(val) => pageSizeChange(val, 'params')"
        />
      </Col>
    </Row>

    <!-- 新增和编辑文章 -->
    <Modal
      v-model="contentModal"
      :title="contentTitle == 0 ? '添加广告' : '编辑广告'"
      :mask-closable="false"
      :loading="contentModalLoading"
      @on-ok="addContent"
      @on-cancel="cancelContent"
      width="660"
    >
      <Form
        ref="contentValidate"
        :model="contentformItem"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem label="广告标题" prop="title">
          <Input
            v-model="contentformItem.title"
            placeholder="请输入广告标题"
          ></Input>
        </FormItem>
        <FormItem label="文章描述" prop="remark">
          <Input v-model="contentformItem.remark" type="textarea"></Input>
        </FormItem>
        <FormItem label="状态" prop="status">
          <!-- 1=启用；2=禁用 -->
          <i-switch
            :value="contentformItem.status == 1"
            @on-change="(v) => statusChange(v, 'contentformItem')"
            size="small"
          />
        </FormItem>
        <FormItem label="图片" prop="imgUrl">
          <Upload
            ref="upload"
            :show-upload-list="false"
            :action="uploadUrl"
            :before-upload="beforeUpload"
            :on-success="(value) => handleSuccess(0, value)"
            :on-error="(value) => onError(0, value)"
            :format="['jpg', 'jpeg', 'png']"
            :max-size="2048000"
            :headers="{ token: $sessionToken() }"
          >
            <Button icon="ios-cloud-upload-outline" :loading="uploading"
              >上传图片</Button
            >
          </Upload>
          <div
            v-if="contentformItem.imgUrl && contentformItem.imgUrl.length > 0"
            :style="{ marginTop: '5px' }"
          >
            <Avatar
              shape="square"
              size="large"
              :src="contentformItem.imgUrl[0]"
            />
          </div>
          <div>
            仅支持jpg/png，图片比例为:1:1，建议尺寸：图片尺寸为840px*1200px，不超过5M
          </div>
        </FormItem>
        <FormItem label="发放门店" prop="retCodeList">
          <RadioGroup v-model="is_all" @on-change="retChange">
            <Radio :label="1">
              <span>全部门店</span>
            </Radio>
            <div style="display: inline" @click="changeModal">
              <Radio :label="2">
                <span>指定门店</span>
              </Radio>
            </div>
          </RadioGroup>
        </FormItem>
        <FormItem label="展示门店" prop="showRetType">
          <RadioGroup v-model="contentformItem.showRetType">
            <Radio :label="1">
              <span>一般贸易门店</span>
            </Radio>
            <Radio :label="2">
              <span>保税贸易门店</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="选择关联" prop="redirectUrl">
          <Input
            v-model="contentformItem.redirectUrl"
            placeholder="请选择关联"
            readonly
            @on-focus="showRedirect"
          ></Input>
        </FormItem>
        <FormItem label="排序号">
          <Input
            v-model="contentformItem.sort"
            placeholder="请输入广告的排序号"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 选择门店弹框 -->
    <Modal
      v-model="showStore"
      title="选择门店"
      :closable="false"
      :mask-closable="false"
      width="700"
    >
      <div>
        <Input
          v-model="storeParams.searchKeyStr"
          placeholder="请输入门店名称/账号"
          class="public-inp"
        />
        <Button type="primary" icon="md-search" @click="getStoreList"
          >搜索</Button
        >
        <Table
          class="table"
          border
          stripe
          :columns="columns0"
          :data="storeList.data || []"
          @on-selection-change="selectionStore"
        >
        </Table>
        <div>
          <Page
            :style="{ marginTop: '20px' }"
            :total="storeList.total"
            :current.sync="storeParams.page"
            :page-size-opts="[10, 20, 30, 100]"
            :page-size="storeParams.pageSize"
            show-sizer
            show-total
            prev-text="Previous"
            next-text="Next"
            show-elevator
            @on-change="(val) => pageNumChange(val, 'storeParams')"
            @on-page-size-change="(val) => pageSizeChange(val, 'storeParams')"
          />
        </div>
      </div>
      <div slot="footer">
        <Button type="text" size="large" @click="cancelStore">取消</Button>
        <Button type="primary" size="large" @click="addStore">确定</Button>
      </div>
    </Modal>
    <!-- 关联弹框 -->
    <Modal
      v-model="show_redirect"
      title="选择关联"
      :mask-closable="false"
      width="700"
    >
      <div class="status" style="justify-content: center">
        <div
          v-for="(item, index) in linkList"
          :key="index"
          :class="[
            'status-item',
            selTab == item.urlType ? 'status-item-active' : '',
          ]"
          @click="changeType(item.urlType)"
        >
          {{ item.name }}
        </div>
      </div>
      <div v-show="selTab == 1">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :columns="columnsSpu"
          :data="spuList.data"
        >
        </Table>
        <Page
          :style="{ marginTop: '20px' }"
          :total="spuList.total"
          :current.sync="spuParams.page"
          :page-size-opts="[10, 20, 30, 100]"
          :page-size="spuParams.pageSize"
          show-sizer
          show-total
          prev-text="Previous"
          next-text="Next"
          show-elevator
          @on-change="(val) => pageNumChange(val, 'spuParams')"
          @on-page-size-change="(val) => pageSizeChange(val, 'spuParams')"
        />
      </div>
      <div v-show="selTab == 2">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :columns="columnsCon"
          :data="conList.list"
        >
        </Table>
        <Page
          :style="{ marginTop: '20px' }"
          :total="conList.total"
          :current.sync="conParams.pageNum"
          :page-size-opts="[10, 20, 30, 100]"
          :page-size="conParams.pageSize"
          show-sizer
          show-total
          prev-text="Previous"
          next-text="Next"
          show-elevator
          @on-change="(val) => pageNumChange(val, 'conParams')"
          @on-page-size-change="(val) => pageSizeChange(val, 'conParams')"
        />
      </div>
      <div v-show="selTab == 3">
        <Form
          ref="redirectVa"
          :model="redirectForm"
          :rules="redirectRule"
          :label-width="80"
        >
          <FormItem label="链接类型" prop="redirectType">
            <RadioGroup v-model="redirectForm.redirectType">
              <Radio label="0">
                <span>内部连接</span>
              </Radio>
              <Radio label="1">
                <span>外部链接</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="链接地址" prop="redirectUrl">
            <Input
              v-model="redirectForm.redirectUrl"
              placeholder="请输入链接地址"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div v-show="selTab == 4"></div>
      <div slot="footer">
        <Button type="text" size="large" @click="cancelRedirect">取消</Button>
        <Button type="primary" size="large" @click="addRedirect">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
const validateSelfHandler = (msg, rule, value, callback) => {
  if (new RegExp(rule).test("" + value)) {
    callback();
  } else {
    callback(new Error(msg));
  }
};
export default {
  data() {
    const validateMainImage = (rule, value, callback) => {
      if (value && value.length) {
        callback();
      } else {
        callback(new Error("图片不能为空"));
      }
    };
    const validateRet = (rule, value, callback) => {
      if (
        this.is_all == null ||
        this.is_all == undefined ||
        this.is_all == ""
      ) {
        callback(new Error("请选择发放门店"));
      } else {
        callback();
      }
    };
    const validateUrl = (rule, value, callback) => {
      if (!this.contentformItem.redirectUrl) {
        callback(new Error("请选择关联"));
      } else {
        callback();
      }
    };
    const columns = [
      {
        title: "编号",
        slot: "no",
        width: 80,
      },
      {
        title: "标题",
        key: "title",
      },
      {
        title: "类型",
        key: "urlType",
        render: (h, params) => {
          // (1:品牌(brand); 2=素材(material); 3=超链接(link); 4=直播链接(live)
          let s = params.row.urlType;
          var text = "";
          switch (s) {
            case 1:
              text = "品牌链接";
              break;
            case 2:
              text = "素材链接";
              break;
            case 3:
              text = "超链接";
              break;
            case 4:
              text = "直播链接";
            default:
              text = "12312";
              break;
          }
          return h("span", text);
        },
      },
      {
        title: "图片",
        slot: "imgUrl",
        width: "100",
      },
      {
        title: "创建时间",
        key: "createTime",
        render: (h, params) => {
          let text = this.tools.formatDate(params.row.createTime, true);
          return h("span", text);
        },
      },
      {
        title: "状态",
        slot: "status",
      },
      {
        title: "操作",
        slot: "action",
      },
    ];
    const columns0 = [
      {
        type: "selection",
        width: 60,
        align: "center",
        fixed: "left",
      },
      {
        title: "门店ID",
        key: "retCode",
        align: "center",
        ellipsis: true,
      },
      {
        title: "名称",
        key: "retName",
      },
      {
        title: "账号",
        key: "contactMobile",
        width: 120,
      },
      {
        title: "联系人",
        key: "contacTperson",
        width: 100,
        ellipsis: true,
      },
      {
        title: "关联服务商",
        key: "fwName",
        width: 120,
        ellipsis: true,
      },
    ];
    const columnsSpu = [
      {
        title: "选中",
        align: "center",
        key: "checkBox",
        width: 80,
        render: (h, params) => {
          return h("div", [
            h("Checkbox", {
              props: {
                value: params.row.checkBox,
              },
              on: {
                "on-change": (e) => {
                  this.spuList.data.forEach((items) => {
                    this.$set(items, "checkBox", false);
                  });
                  this.spuList.data[params.index].checkBox = e;
                  this.handleSelectCheck(params.row, 0);
                },
              },
            }),
          ]);
        },
      },
      {
        title: "名称",
        key: "name",
      },
      {
        title: "所属分类",
        key: "categoryName",
      },
      {
        title: "品牌",
        key: "brandName",
      },
    ];
    const columnsCon = [
      {
        title: "选中",
        align: "center",
        key: "checkBox",
        width: 80,
        render: (h, params) => {
          return h("div", [
            h("Checkbox", {
              props: {
                value: params.row.checkBox,
                disabled: params.row.status != 1,
              },
              on: {
                "on-change": (e) => {
                  this.conList.list.forEach((items) => {
                    this.$set(items, "checkBox", false);
                  });
                  this.conList.list[params.index].checkBox = e;
                  this.handleSelectCheck(params.row, 1);
                },
              },
            }),
          ]);
        },
      },
      {
        title: "标题",
        key: "title",
      },
      {
        title: "描述",
        key: "remark",
      },
      {
        title: "所属分类",
        key: "typeName",
      },
    ];

    return {
      // 关联
      conParams: {
        pageNum: 1,
        pageSize: 10,
      },
      selectedConId: "",
      columnsCon,
      conList: {},

      selectedSpu: "",
      columnsSpu,
      spuList: {},
      spuParams: {
        page: 1,
        pageSize: 10,
        status: 0,
      },

      redirectRule: {
        redirectType: [
          {
            type: "string",
            required: true,
            message: "请选择链接类型",
            trigger: "change",
          },
        ],
        redirectUrl: [
          { required: true, message: "请输入链接地址", trigger: "blur" },
        ],
      },
      redirectForm: {
        redirectType: "",
        redirectUrl: "",
      },
      show_redirect: false,
      linkList: [
        {
          urlType: 1,
          name: "SPU链接",
        },
        {
          urlType: 2,
          name: "素材链接",
        },
        {
          urlType: 3,
          name: "超链接",
        },
        {
          urlType: 4,
          name: "直播链接",
        },
      ],
      selTab: 1, //默认选中的是SPU链接

      // 门店
      showStore: false,
      columns0,
      storeList: {},
      storeParams: {
        page: 1,
        pageSize: 10,
        searchKeyStr: "",
        platformStatus: 1,
      },

      contentTitle: 0, //添加广告
      contentModal: false, //广告弹框
      contentformItem: {
        imgUrl: [],
        redirectUrl: "", //链接地址:{SPU=>SPU编码 ; 素材=> 存素材Id ; 超链接=>存链接的URL }
        remark: "",
        retCodeList: [],
        sectionCode: "",
        showRetType: "",
        sort: "",
        status: 1,
        title: "",
        urlType: "", //链接类型(1:品牌(brand); 2=素材(material); 3=超链接(link); 4=直播链接(live)
        redirectType: "", //超链接时生效：{ 0:内部连接 1：外部连接 }
      },
      ruleValidate: {
        title: [
          {
            required: true,
            message: "文章标题不能为空",
            trigger: "blur",
          },
          {
            required: true,
            validator: (rule, value, callback) =>
              validateSelfHandler(
                "不为空且不能超过20个字符",
                /^.{1,20}$/,
                value,
                callback
              ),
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            message: "广告描述不能为空",
            trigger: "blur",
          },
        ],
        status: [
          {
            type: "number",
            required: true,
            message: "文章状态不能为空",
            trigger: "change",
          },
        ],
        showRetType: [
          {
            type: "number",
            required: true,
            message: "展示门店不能为空",
            trigger: "change",
          },
        ],
        imgUrl: [
          { required: true, trigger: "change", validator: validateMainImage },
        ],
        retCodeList: [
          { required: true, validator: validateRet, trigger: "change" },
        ],
        redirectUrl: [
          { required: true, validator: validateUrl, trigger: "change" },
        ],
      },
      contentModalLoading: true,

      //new
      loading: false,
      sectionList: [], //版块
      tab: "",
      advList: {}, //广告列表
      params: {
        pageNum: 1,
        pageSize: 10,
        sectionCode: "",
        title: "",
      },
      columns,

      uploadUrl: "",
      uploading: false,

      is_all: 1, //全部门店
    };
  },

  created() {
    this.uploadUrl = axios.defaults.baseURL + "base/file/publicUpload";
    this.init();
  },
  methods: {
    handleSelectCheck(v, type) {
      if (type == 0) {
        this.selectedSpu = v.code;
      } else {
        this.selectedConId = v.id;
      }
    },

    addRedirect() {
      if (this.selTab == 1) {
        if (!this.selectedSpu) {
          this.$Message.error("尚未选择SPU");
          return false;
        }
        this.contentformItem.urlType = this.selTab;
        this.show_redirect = false;
        this.contentformItem.redirectUrl = this.selectedSpu;
      }
      if (this.selTab == 2) {
        if (!this.selectedConId) {
          this.$Message.error("尚未选择素材链接");
          return false;
        }
        this.contentformItem.urlType = this.selTab;
        this.show_redirect = false;
        this.contentformItem.redirectUrl = this.selectedConId;
      }
      if (this.selTab == 3) {
        let data = { ...this.redirectForm };
        this.$refs["redirectVa"].validate((valid) => {
          if (valid) {
            this.contentformItem.redirectType = data.redirectType;
            this.contentformItem.redirectUrl = data.redirectUrl;
            this.contentformItem.urlType = this.selTab;
            this.show_redirect = false;
          }
        });
      }
    },
    cancelRedirect() {
      Object.keys(this.redirectForm).forEach((key) => {
        this.redirectForm[key] = "";
      });
      this.$refs["redirectVa"].resetFields();
      this.show_redirect = false;
    },
    changeType(e) {
      this.selTab = e;
      this.getLinks();
    },
    getLinks() {
      if (this.selTab == 1) {
        this.getSpuList();
      }
      if (this.selTab == 2) {
        this.getContentList();
      }
    },
    getSpuList() {
      let data = this.spuParams;
      this.$api.spuSearch(data).then((res) => {
        if (res.code == "200") {
          this.spuList = res;
        }
      });
    },
    getContentList() {
      return new Promise((reslove) => {
        let params = this.conParams;
        this.$api.contentList(params).then((res) => {
          if (res.code == 200) {
            this.conList = res.data;
            reslove(this.conList);
          }
        });
      });
    },

    showRedirect() {
      this.show_redirect = true;
      let d = this.contentformItem;
      this.selTab = d.urlType || 1;
      if (d.urlType == 3) {
        Object.keys(this.redirectForm).forEach((key) => {
          this.redirectForm[key] = d[key];
        });
      }
      if (d.urlType == 1) {
        this.spuList.data.some((item, index) => {
          if (d.redirectUrl == item.code) {
            this.$set(this.spuList.data[index], "checkBox", true);
          }
        });
      }
      if (d.urlType == 2) {
        this.getContentList().then((res) => {
          if (res) {
            this.conList.list.some((item, index) => {
              if (d.redirectUrl == item.id) {
                this.$set(this.conList.list[index], "checkBox", true);
              }
            });
          }
        });
      }
    },

    retChange(e) {
      this.contentformItem.retCodeList =
        e == 1 ? [] : this.contentformItem.retCodeList;
    },

    changeModal() {
      this.showStore = true;
      this.getStoreList();
    },
    // 获取门店列表
    getStoreList() {
      let params = this.storeParams;
      this.$api["shopInfoQueryList"](params).then((res) => {
        this.storeList = res;
        let data = res.data;
        if (this.contentformItem.retCodeList.length > 0) {
          const checkedData = data.reduce((prev, cuur) => {
            return prev.concat(
              this.contentformItem.retCodeList.includes(cuur.retCode)
                ? { ...cuur, _checked: true }
                : cuur
            );
          }, []);
          this.storeList.data = checkedData;
        }
      });
    },
    selectionStore(e) {
      let list = [];
      e.map((item) => {
        list.push(item.retCode);
      });
      this.contentformItem.retCodeList = list;
    },
    addStore() {
      if (this.contentformItem.retCodeList.length == 0) {
        this.$Message.error("尚未选择指定门店");
        return false;
      }
      this.showStore = false;
    },
    cancelStore() {
      if (this.contentformItem.retCodeList.length == 0) {
        this.is_all = 1;
      }
      this.showStore = false;
    },
    //获取板块名称
    init() {
      this.$api.sectionAll({}).then((res) => {
        if (res.code == 200) {
          this.sectionList = res.data;
          this.tab = res.data[0].code;
          this.getList(res.data[0].code);
          this.getLinks();
        }
      });
    },
    handleSearch(e) {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.getList(e);
    },
    getList(va) {
      this.loading = true;
      let params = this.params;
      params.sectionCode = va;
      this.$api
        .sectionList(params)
        .then((res) => {
          if (res.code == 200) {
            this.loading = false;
            this.advList = res.data;
          }
        })
        .finally((err) => {
          this.loading = false;
        });
    },
    tabNav(e) {
      this.tab = e;
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.getList(e);
    },
    resetList() {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.params.title = "";
      this.$nextTick(() => {
        this.getList(this.params.sectionCode);
      });
    },
    // 页码
    pageNumChange(pageNum, type) {
      if (type == "params") {
        this[type].pageNum = pageNum;
        this.getList(this.tab);
      } else if (type == "storeParams") {
        this[type].page = pageNum;
        this.getStoreList();
      } else if (type == "spuParams") {
        this[type].page = pageNum;
        this.getSpuList();
      } else {
        this[type].pageNum = pageNum;
        this.getContentList();
      }
    },
    // 页数
    pageSizeChange(pageSize, type) {
      this[type].pageSize = pageSize;

      if (type == "params") {
        if (this[type].pageNum == 1) {
          this.getList(this.tab);
        } else {
          this[type].pageNum = 1;
        }
      } else if (type == "storeParams") {
        if (this[type].page == 1) {
          this.getStoreList();
        } else {
          this[type].page = 1;
        }
      } else if (type == "spuParams") {
        if (this[type].page == 1) {
          this.getSpuList();
        } else {
          this[type].page = 1;
        }
      } else {
        if (this[type].pageNum == 1) {
          this.getContentList();
        } else {
          this[type].pageNum = 1;
        }
      }
    },

    openContent(d) {
      this.contentTitle = d ? 1 : 0;
      if (d) {
        Object.keys(this.contentformItem).forEach((key) => {
          this.contentformItem[key] = d[key];
        });
        this.contentformItem.imgUrl = d.imageUrlView;
        if (d.retCodeList) {
          this.is_all = 2;
          this.contentformItem.retCodeList = d.retCodeList.split(",");
        } else {
          this.contentformItem.retCodeList = [];
        }
        this.selTab = d.urlType;
        if (d.urlType == 3) {
          Object.keys(this.redirectForm).forEach((key) => {
            this.redirectForm[key] = d[key];
          });
        }
        if (d.urlType == 1) {
          this.spuList.data.some((item, index) => {
            if (d.redirectUrl == item.code) {
              this.$set(this.spuList.data[index], "checkBox", true);
            }
          });
        }
        if (d.urlType == 2) {
          this.getContentList().then((res) => {
            if (res) {
              this.conList.list.some((item, index) => {
                if (d.redirectUrl == item.id) {
                  this.$set(this.conList.list[index], "checkBox", true);
                }
              });
            }
          });
        }
        this.contentformItem.id = d.id;
      }
      this.$nextTick(() => {
        this.contentModal = true;
      });
    },
    beforeUpload(d) {
      let size = d.size;
      let type = d.type;
      if (size > 2048000) {
        this.$Message.error("图片不可大于2M");
        return false;
      }
      if (type != "image/png" && type != "image/jpg" && type != "image/jpeg") {
        this.$Message.error("仅支持jpg/png");
        return false;
      }
      this.uploading = true;
    },
    handleSuccess(index, value) {
      this.uploading = false;
      let data = value.data;
      switch (index) {
        case 0:
          if (this.contentformItem.imgUrl == undefined) {
            this.contentformItem.imgUrl = [];
          } else {
            this.contentformItem.imgUrl = [data.url];
          }
          break;
        default:
          break;
      }
    },
    onError(index, value) {
      switch (index) {
        case 0:
          this.contentformItem.imgUrl = [];
          break;
        default:
          break;
      }
      this.uploading = false;
      this.$Message.error("上传失败");
    },
    addContent() {
      this.contentModalLoading = false;
      this.$nextTick(() => {
        this.contentModalLoading = true;
      });
      let data = { ...this.contentformItem };
      data.sectionCode = this.tab;
      let http = "sectionAdd";
      this.$refs["contentValidate"].validate((valid) => {
        if (valid) {
          if (this.contentTitle == 1) {
            http = "sectionUpt";
          }
          this.$api[http](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.cancelContent();
              this.getList(this.tab);
            }
          });
        }
      });
    },
    // 文章弹框取消
    cancelContent() {
      Object.keys(this.contentformItem).forEach((key) => {
        this.contentformItem[key] = "";
      });
      this.is_all = 1; //恢复至全部门店
      this.selTab = 1; //
      if (this.selectedSpu) {
        this.getSpuList();
      }
      if (this.selectedConId) {
        this.getContentList();
      }
      this.selectedSpu = "";
      this.selectedConId = "";
      this.$refs["redirectVa"].resetFields();
      this.$refs["contentValidate"].resetFields();
      this.contentModal = false;
    },

    // 修改状态
    statusChange(e, tab) {
      this[tab].status = e ? 1 : 2;
    },
    updateState(v, d) {
      d.status = v ? 1 : 2;
      delete d.createTime;
      delete d.updateTime;
      d.imgUrl = d.imageUrlView;
      d.retCodeList = d.retCodeList ? d.retCodeList.split(",") : [];
      let http = "sectionUpt";
      this.$api[http](d).then((res) => {
        if (res.code == "200") {
          this.$Message.success(v ? "启用成功" : "禁用成功");
          this.getList(this.tab);
        }
      });
    },

    removeContent(row) {
      let id = row.id;
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除该广告吗`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.$api
            .sectionDel({ id: id })
            .then((res) => {
              if (res.code == 200) {
                this.$Message.success("删除成功");
                this.params.pageNum = 1;
                this.params.pageSize = 10;
                this.getList(this.tab);
              } else {
                this.$Message.error("删除失败");
              }
            })
            .catch((err) => {
              this.$Message.error(res.message);
            });
        },
      });
    },
  },
};
</script>

<style scoped>
.status {
  display: flex;
  margin-bottom: 15px;
}

.status .status-item {
  min-width: 100px;
  text-align: center;
  height: 32px;
  line-height: 30px;
  font-size: 12px;
  padding: 0 20px;
  cursor: pointer;
  user-select: none;
  transition: 0.25s;
  outline: none;
  background-color: #fff;
  color: #5586ff;
  border: 1px solid #5586ff;
  white-space: nowrap;
}

.status .status-item:first-child {
  border-radius: 4px 0 0 4px;
}

.status .status-item:last-child {
  border-radius: 0 4px 4px 0;
}

.status .status-item:not(:first-child) {
  margin-left: -1px;
}

.status .status-item-active {
  color: #fff;
  border-color: #5586ff;
  background-color: #5586ff;
}
.table {
  margin-top: 10px;
}
.img_url {
  width: 50px;
  height: 50px;
  margin: 10px;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/content/advList.vue